import { createStore, combineReducers, applyMiddleware } from 'redux';
import { createForms } from 'react-redux-form';
import { Comments, Tasks,Log, Alltasks,Timetables,openAIResponse } from './LogReducer'
import  thunk  from 'redux-thunk';
import loger, { logger } from 'redux-logger';

//each reducer function is called when the dispatch is invoked. 
export const ConfigureStore = () => {
    const store = createStore(
      combineReducers({
        dailylogs: Comments,
        tasks: Tasks,
        log: Log,
        alltasks: Alltasks,
        timetables: Timetables,
        openAIResponse: openAIResponse 
      }),
      applyMiddleware (thunk, logger)
    );
    return store;
}